<template>
  <slot name="albumName"></slot>
  <slot name="gallery"></slot>
</template>

<script>
export default {
  setup() {
    return {};
  }
};
</script>

<style scoped></style>
